document.addEventListener('DOMContentLoaded', () => {
  const input = document.getElementById('CartDiscountInput');
  const applyBtn = document.getElementById('ApplyDiscountBtn');
  const errorBox = document.getElementById('DiscountError');

  if (!input || !applyBtn) return;

  const showError = (msg) => {
    errorBox.textContent = msg;
    errorBox.classList.remove('hidden');
  };

  const clearError = () => {
    errorBox.textContent = '';
    errorBox.classList.add('hidden');
  };

  // APPLY DISCOUNT
  applyBtn.addEventListener('click', () => {
    clearError();

    const code = input.value.trim();
    if (!code) {
      showError('Please enter a discount code.');
      return;
    }

    applyBtn.disabled = true;
    applyBtn.textContent = 'Applying…';

    window.location.href =
      `/discount/${encodeURIComponent(code)}?redirect=/cart`;
  });

  // REMOVE DISCOUNT
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-remove-discount]')) return;

    e.preventDefault();
    window.location.href = `/discount/?redirect=/cart`;
  });
});
